import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

export default function ProtectedRoute({
  component: Component,
  allowedRoles,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props => {
        const log = cookies.get('log') === 'true' || cookies.get('log') === true
        const rolCookie = cookies.get('rol')
        const rol = Number(rolCookie)

        // Normalizamos allowedRoles a _números_
        const allowedNums = allowedRoles.map(r => Number(r))
        const isAllowed = log && allowedNums.includes(rol)

        console.log('🔐 ProtectedRoute:', {
          path: rest.path,
          log,
          rolCookie,
          rol,
          allowedRoles,
          allowedNums,
          isAllowed
        })

        if (!log) {
          return <Redirect to="/login" />
        }
        if (!isAllowed) {
          return <Redirect to="/errorpermiso" />
        }
        return <Component {...props} />
      }}
    />
  )
}